<template>
  <div>
    <div>
      <div v-if="!clarifications.length" class="panel">
        <div class="panel-block empty-panel">
          <section v-if="!clarifications.length" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>Nenhum esclarecimento.</p>
            </div>
          </section>
        </div>
      </div>

      <b-table
        class="manifestacao-listagem"
        hoverable
        detailed
        striped
        detail-key="id"
        v-if="clarifications.length"
        :data="clarifications"
        :opened-detailed.sync="defaultOpenedDetails"
        :row-class="classeLinhaManifestacao"
      >
        <b-table-column centered numeric field="id" label="Nro" width="80" v-slot="props">
          {{ String(props.row.id).padStart(2, '0') }}
        </b-table-column>

        <b-table-column field="subject" label="Assunto" v-slot="props">
          {{ props.row.subject }}
        </b-table-column>

        <b-table-column centered field="status" label="Situação" width="169" v-slot="props">
          <ManifestacaoSituacaoBadge
            :status="props.row.status"
            :para-licitante="!company.buyer"
            :manifestacao="props.row"
            :company="company"
          />
        </b-table-column>

        <b-table-column centered field="createdAt" label="Data" width="185" v-slot="props">
          {{ props.row.createdAt | formatDate }}
          <p style="font-size: 0.85rem; color: #8b8b8b; margin-left: 5px">(Horário local)</p>
        </b-table-column>

        <template v-slot:detail="props">
          <AppMensagem
            rotulo-remetente="PEDIDO DE ESCLARECIMENTO ENVIADO POR"
            :nome="props.row.question.name"
            :email="props.row.question.email"
            :data="new Date(props.row.createdAt)"
          >
            <template #prefix>
              <ManifestacaoAnexosLista :anexos="props.row.anexos" />
            </template>
            <ManifestacaoMensagemTexto :texto="props.row.question.message" />
          </AppMensagem>

          <hr v-if="temResposta(props.row)" class="manifestacao-separador" />

          <AppMensagem
            :rotulo-remetente="rotuloResposta(props.row)"
            :nome="props.row.response.name"
            :email="props.row.response.email"
            :data="new Date(props.row.response.date)"
            v-if="temResposta(props.row)"
          >
            <template #prefix>
              <ManifestacaoAnexosLista :anexos="props.row.anexosResposta" />
            </template>
            <ManifestacaoMensagemTexto :texto="props.row.response.message" />
          </AppMensagem>
          <article class="media" v-if="crier && situation <= 4 && !temResposta(props.row)">
            <div class="media-content">
              <ManifestacaoFormLayout class="manifestacao-resposta-form">
                <b-field
                  label="Resposta"
                  :type="campoInvalido('response', 'response') ? 'is-danger' : ''"
                  :message="
                    campoInvalido('response', 'response') ? 'Resposta é um campo obrigatório' : ''
                  "
                >
                  <b-input type="textarea" v-model="$v.response.response.$model" />
                </b-field>
                <template #upload>
                  <AppUploadPanel
                    class="column manifestacao-form-upload"
                    v-model="arquivosResposta"
                  />
                </template>
                <template #actions>
                  <b-button
                    :loading="loading"
                    type="is-primary send-button"
                    @click.prevent.stop="answerClarification(props.row)"
                  >
                    Enviar
                  </b-button>
                </template>
              </ManifestacaoFormLayout>
            </div>
          </article>
        </template>
      </b-table>
    </div>

    <br />

    <div class="clarification" v-if="!company.buyer && canAsk">
      <h1 class="title is-4">Enviar Pergunta</h1>
      <form @submit.prevent="createClarification">
        <ManifestacaoFormLayout>
          <b-field grouped class="column-direction-touch">
            <b-field
              expanded
              label="Nome"
              :type="campoInvalido('name', 'data') ? 'is-danger' : ''"
              :message="campoInvalido('name', 'data') ? 'Nome é um campo obrigatório' : ''"
            >
              <b-input
                custom-class="uppercase"
                :disabled="logged"
                v-model="$v.data.name.$model"
                @blur="event => converterMaiusculo('name', event.target.value, 'data')"
              />
            </b-field>
            <b-field
              v-if="logged"
              label="CNPJ"
              :type="campoInvalido('cnpj', 'data') ? 'is-danger' : ''"
              :message="
                campoInvalido('cnpj', 'data')
                  ? 'CNPJ é um campo obrigatório. Insira um número válido'
                  : ''
              "
            >
              <b-input
                :disabled="logged"
                maxlength="18"
                :has-counter="false"
                v-mascara:cnpj
                v-model="$v.data.cnpj.$model"
              />
            </b-field>
            <b-field
              v-else
              label="CPF"
              :type="campoInvalido('cpf', 'data') ? 'is-danger' : ''"
              :message="
                campoInvalido('cpf', 'data')
                  ? 'CPF é um campo obrigatório. Insira um número válido'
                  : ''
              "
            >
              <b-input
                :disabled="logged"
                maxlength="14"
                :has-counter="false"
                v-mascara:cpf
                v-model="$v.data.cpf.$model"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </b-field>
            <b-field
              expanded
              label="E-mail"
              :type="campoInvalido('email', 'data') ? 'is-danger' : ''"
              :message="campoInvalido('email', 'data') ? 'Insira um e-mail válido' : ''"
            >
              <b-input
                :disabled="logged"
                v-model="$v.data.email.$model"
                @input="data.email = data.email.toLowerCase()"
              />
            </b-field>
          </b-field>

          <b-field
            expanded
            label="Assunto"
            :type="campoInvalido('subject', 'data') ? 'is-danger' : ''"
            :message="campoInvalido('subject', 'data') ? 'Assunto é um campo obrigatório' : ''"
          >
            <b-input
              custom-class="uppercase"
              v-model="$v.data.subject.$model"
              @input="valor => converterMaiusculo('subject', valor, 'data')"
            />
          </b-field>

          <b-field
            label="Pergunta"
            :type="campoInvalido('message', 'data') ? 'is-danger' : ''"
            :message="campoInvalido('message', 'data') ? 'Pergunta é um campo obrigatório' : ''"
          >
            <b-input type="textarea" v-model="$v.data.message.$model" />
          </b-field>

          <template #upload>
            <AppUploadPanel class="column manifestacao-form-upload" v-model="arquivos" />
          </template>

          <template #actions>
            <button
              type="submit"
              class="button is-primary send-button"
              :class="{ ' is-loading': loading }"
            >
              Enviar
            </button>
          </template>
        </ManifestacaoFormLayout>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { email, required, requiredIf } from 'vuelidate/lib/validators';
import { isValidCpf } from '@brazilian-utils/validators';

import field from '@/mixins/formulario';
import { formatarData as formatDate } from '@/utils/format';
import { funcoes as functions } from '@/utils/enumerados';

import AppMensagem from '@/components/AppMensagem';
import AppUploadPanel from '@/components/AppUploadPanel';
import ManifestacaoAnexosLista from '@/components/ManifestacaoAnexosLista';
import ManifestacaoMensagemTexto from '@/components/ManifestacaoMensagemTexto';
import ManifestacaoFormLayout from '@/components/ManifestacaoFormLayout';
import ManifestacaoSituacaoBadge from '@/components/ManifestacaoSituacaoBadge';
import buildManifestacaoFormData from '@/utils/manifestacaoFormData';
import {
  getManifestacaoErrorMessage,
  manifestacaoTemResposta,
  rotuloRemetenteResposta,
} from '@/utils/manifestacaoError';
import { classeLinhaManifestacaoExpandida } from '@/utils/manifestacaoListagem';

export default {
  name: 'AuctionClarifications',
  mixins: [field],
  components: {
    AppMensagem,
    AppUploadPanel,
    ManifestacaoAnexosLista,
    ManifestacaoMensagemTexto,
    ManifestacaoFormLayout,
    ManifestacaoSituacaoBadge,
  },
  filters: {
    formatDate,
  },
  data() {
    const data = {
      cnpj: null,
      cpf: null,
      email: '',
      message: '',
      name: '',
      subject: '',
    };
    const response = {
      response: '',
    };

    return {
      arquivos: [],
      arquivosResposta: [],
      data,
      defaultOpenedDetails: [],
      loading: false,
      response,
    };
  },
  computed: {
    ...mapState('auctionsClarifications', ['clarifications']),
    ...mapState('companies', ['company']),
    ...mapGetters({
      auction: 'obterOfertaCompra',
      deadlines: 'obterOfertaCompraPrazos',
      function: 'getFunction',
      logged: 'getLogged',
    }),
    canAsk() {
      const deadline = this.deadlines.find(elemento => elemento.id === 2);
      if (deadline) {
        return this.situation === 3 && deadline.data_ate >= Date.now();
      }
      return false;
    },
    crier() {
      return this.function === functions.PREGOEIRO;
    },
    situation() {
      return this.auction.situacao.id;
    },
  },
  watch: {
    company() {
      this.loadCompanyData();
    },
  },
  validations: {
    data: {
      cnpj: {
        required: requiredIf(function validarcnpj() {
          return this.company.cnpj;
        }),
      },
      cpf: {
        required: requiredIf(function validarcpf() {
          return !this.company.cnpj;
        }),
        validCpf() {
          if (!this.logged) return isValidCpf(this.data.cpf);
          return true;
        },
      },
      email: { email, required },
      message: { required },
      name: { required },
      subject: { required },
    },
    response: {
      response: { required },
    },
  },
  sockets: {
    'auction:clarifications': function updateClarifications(clarification) {
      this.updateAuctionClarifications(clarification);
      this.defaultOpenedDetails = this.defaultOpenedDetails.slice();
    },
  },
  methods: {
    ...mapActions('auctionsClarifications', [
      'createAuctionClarification',
      'answerAuctionClarification',
      'updateAuctionClarifications',
    ]),
    async answerClarification(clarification) {
      if (this.validar('response')) {
        this.loading = true;
        try {
          await this.answerAuctionClarification({
            auctionId: this.auction.id,
            clarificationId: clarification.id,
            data: buildManifestacaoFormData(this.response, this.arquivosResposta),
          });
          this.$alerta('Respondido', 'is-success');
          this.$v.data.$reset();
          this.arquivosResposta = [];
          this.limparCampos('response');
          this.atualizarDetalheAberto();
        } catch (error) {
          this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
        }
        this.loading = false;
      }
    },
    atualizarDetalheAberto() {
      this.defaultOpenedDetails = this.defaultOpenedDetails.slice();
    },
    temResposta(row) {
      return manifestacaoTemResposta(row);
    },
    rotuloResposta(row) {
      return rotuloRemetenteResposta(row, 'esclarecimento');
    },
    classeLinhaManifestacao(row) {
      return classeLinhaManifestacaoExpandida(row, this.defaultOpenedDetails);
    },
    async createClarification() {
      if (this.validar('data')) {
        this.loading = true;
        try {
          const formData = buildManifestacaoFormData(
            { ...this.data, empresaId: this.company.id || null },
            this.arquivos,
          );

          await this.createAuctionClarification({
            auctionId: this.auction.id,
            data: formData,
          });
          this.$alerta('Dados salvos', 'is-success');
          this.arquivos = [];
          this.$v.data.$reset();
          this.limparCampos('data');
          if (this.company) this.loadCompanyData();
        } catch (error) {
          this.$alerta(getManifestacaoErrorMessage(error), 'is-danger');
        }
        this.loading = false;
      }
    },
    loadCompanyData() {
      this.data.name = this.company.socialDenomination;
      this.data.cnpj = this.company.cnpj;
      this.data.email = this.company.email;
    },
  },
  created() {
    this.loadCompanyData();
  },
};
</script>

<style lang="scss" scoped>
.empty-panel {
  justify-content: center !important;
}

.message {
  white-space: pre-line;
}

.send-button {
  margin-top: 0.75rem;
  width: 150px;
}

@media (max-width: 1023px) {
  .send-button {
    width: 100%;
  }
}
</style>
<style src="@/styles/manifestacao.scss" lang="scss" scoped />
